export const OVERWRITE_ACTION = Object.freeze({
  NONE: "none",
  CONFIRM: "confirm",
  MANUAL_REQUIRED: "manual-required",
});

export function getOverwriteAction(reason, manualModeActive) {
  if (reason !== "overwrite-confirmation-required") {
    return OVERWRITE_ACTION.NONE;
  }

  return manualModeActive
    ? OVERWRITE_ACTION.CONFIRM
    : OVERWRITE_ACTION.MANUAL_REQUIRED;
}
